/* Curly N Covered - Video Swipe Rail
   Lazy load, Autoplay nur im Sichtbereich, Ton pro Karte, Story-Fortschritt
   v2: startet auch, wenn die Section erst beim Scrollen sichtbar wird,
       und zeigt einen Play-Button, falls der Browser Autoplay blockiert. */
(function () {
  if (window.cncVideoSwipeLoaded) return;
  window.cncVideoSwipeLoaded = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  var PLAY_ICON =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>';

  function CncVideoSwipe(root) {
    this.root = root;
    this.rail = root.querySelector('[data-cnc-vs-rail]');
    this.cards = Array.prototype.slice.call(root.querySelectorAll('[data-cnc-vs-card]'));
    this.segments = Array.prototype.slice.call(root.querySelectorAll('[data-cnc-vs-segment]'));
    this.prevBtn = root.querySelector('[data-cnc-vs-prev]');
    this.nextBtn = root.querySelector('[data-cnc-vs-next]');
    this.activeIndex = 0;
    this.inView = false;
    this.ticking = null;

    if (!this.rail || !this.cards.length) return;

    this.ensureArrows();
    this.setupDrag();
    this.setupLazyLoad();
    this.setupPlayButtons();
    this.setupSound();
    this.setupNavigation();
    this.setupScroll();
    this.setupSectionVisibility();
    this.updateActive();
    root.setAttribute('data-cnc-vs-ready', 'true');
  }

  /* Quellen erst kurz vor dem Sichtbereich setzen */
  CncVideoSwipe.prototype.attach = function (video) {
    if (!video || video.dataset.cncLoaded === 'true') return;
    var sources = video.querySelectorAll('source[data-src]');
    for (var i = 0; i < sources.length; i++) {
      sources[i].src = sources[i].dataset.src;
      sources[i].removeAttribute('data-src');
    }
    video.dataset.cncLoaded = 'true';
    video.preload = 'auto';
    video.load();
  };

  CncVideoSwipe.prototype.setupLazyLoad = function () {
    var self = this;
    var loader = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          self.attach(entry.target);
          loader.unobserve(entry.target);
        });
      },
      { root: null, rootMargin: '300px 0px', threshold: 0 }
    );

    this.cards.forEach(function (card) {
      var video = card.querySelector('video');
      if (video) loader.observe(video);
    });
  };

  /* Play-Button erscheint nur, wenn der Browser das Autoplay verweigert
     (zum Beispiel iOS im Energiesparmodus) */
  CncVideoSwipe.prototype.setupPlayButtons = function () {
    var self = this;
    this.cards.forEach(function (card) {
      var frame = card.querySelector('.cnc-vs__frame');
      var video = card.querySelector('video');
      if (!frame || !video) return;

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'cnc-vs__play';
      button.setAttribute('aria-label', 'Video abspielen');
      button.innerHTML = PLAY_ICON;
      button.addEventListener('click', function (event) {
        event.preventDefault();
        self.attach(video);
        var attempt = video.play();
        if (attempt && attempt.then) {
          attempt.then(function () {
            card.classList.remove('is-blocked');
          }).catch(function () {});
        } else {
          card.classList.remove('is-blocked');
        }
      });
      frame.appendChild(button);
    });
  };

  CncVideoSwipe.prototype.play = function (card) {
    var video = card.querySelector('video');
    if (!video || reduceMotion.matches || !this.inView) return;
    this.attach(video);
    if (!video.paused) return;
    var attempt = video.play();
    if (attempt && attempt.then) {
      attempt
        .then(function () {
          card.classList.remove('is-blocked');
        })
        .catch(function () {
          card.classList.add('is-blocked');
        });
    }
  };

  /* Spielt jede Karte, die im Rail zu mehr als 55 Prozent sichtbar ist */
  CncVideoSwipe.prototype.playVisible = function () {
    var self = this;
    var railBox = this.rail.getBoundingClientRect();
    this.cards.forEach(function (card) {
      var video = card.querySelector('video');
      if (!video) return;
      var box = card.getBoundingClientRect();
      var overlap = Math.min(box.right, railBox.right) - Math.max(box.left, railBox.left);
      if (overlap > box.width * 0.55) {
        self.play(card);
      } else {
        video.pause();
        if (!video.muted) self.muteAll();
      }
    });
  };

  CncVideoSwipe.prototype.pauseAll = function () {
    this.cards.forEach(function (card) {
      var video = card.querySelector('video');
      if (video) video.pause();
    });
    this.muteAll();
  };

  CncVideoSwipe.prototype.muteAll = function (except) {
    this.cards.forEach(function (card) {
      var video = card.querySelector('video');
      if (!video || video === except) return;
      video.muted = true;
      card.classList.remove('is-audible');
    });
  };

  /* Die Inline-Variante bringt keine Pfeile mit. Ohne Touchscreen gaebe es
     dann keine Moeglichkeit zu blaettern, also legen wir sie hier an. */
  CncVideoSwipe.prototype.ensureArrows = function () {
    if (this.prevBtn || this.nextBtn) return;
    var viewport = this.root.querySelector('.cnc-vs__viewport') || this.rail.parentNode;
    if (!viewport) return;

    var icons = {
      prev: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15.4 3.6 7 12l8.4 8.4 1.6-1.6L10.2 12 17 5.2z"/></svg>',
      next: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8.6 3.6 7 5.2 13.8 12 7 18.8l1.6 1.6L17 12z"/></svg>'
    };

    function make(kind, label) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'cnc-vs__arrow cnc-vs__arrow--' + kind;
      button.setAttribute('aria-label', label);
      button.setAttribute('data-cnc-vs-' + kind, '');
      button.innerHTML = icons[kind];
      return button;
    }

    this.prevBtn = make('prev', 'Vorheriges Video');
    this.nextBtn = make('next', 'Nächstes Video');
    this.prevBtn.hidden = true;
    viewport.appendChild(this.prevBtn);
    viewport.appendChild(this.nextBtn);
  };

  /* Ziehen mit der Maus, damit die Leiste auch ohne Touchscreen laeuft */
  CncVideoSwipe.prototype.setupDrag = function () {
    var self = this;
    var down = false;
    var startX = 0;
    var startLeft = 0;
    var moved = 0;

    if (this.rail.scrollWidth > this.rail.clientWidth + 4) {
      this.rail.classList.add('is-draggable');
    }

    this.rail.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'touch' || event.button !== 0) return;
      if (event.target.closest('button, a')) return;
      down = true;
      moved = 0;
      startX = event.clientX;
      startLeft = self.rail.scrollLeft;
      self.rail.classList.add('is-dragging');
    });

    window.addEventListener('pointermove', function (event) {
      if (!down) return;
      var dx = event.clientX - startX;
      if (Math.abs(dx) > moved) moved = Math.abs(dx);
      self.rail.scrollLeft = startLeft - dx;
      event.preventDefault();
    });

    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      self.rail.classList.remove('is-dragging');
      self.updateActive();
      self.playVisible();
    });

    this.rail.addEventListener(
      'click',
      function (event) {
        if (moved > 6) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );
  };

  CncVideoSwipe.prototype.setupSound = function () {
    var self = this;
    this.cards.forEach(function (card) {
      var button = card.querySelector('[data-cnc-vs-sound]');
      var video = card.querySelector('video');
      if (!button || !video) return;
      button.addEventListener('click', function () {
        var turnOn = video.muted;
        self.muteAll(video);
        video.muted = !turnOn;
        card.classList.toggle('is-audible', turnOn);
        button.setAttribute('aria-pressed', turnOn ? 'true' : 'false');
        if (turnOn) self.play(card);
      });
    });
  };

  CncVideoSwipe.prototype.setupScroll = function () {
    var self = this;
    this.rail.addEventListener('scroll', function () {
      window.clearTimeout(self.scrollTimer);
      self.scrollTimer = window.setTimeout(function () {
        self.updateActive();
        self.playVisible();
      }, 90);
    });
  };

  CncVideoSwipe.prototype.setupNavigation = function () {
    var self = this;

    function step(direction) {
      var card = self.cards[0];
      var width = card.getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(self.rail).columnGap || '12') || 12;
      self.rail.scrollBy({ left: direction * (width + gap), behavior: 'smooth' });
    }

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', function () {
        step(-1);
      });
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', function () {
        step(1);
      });
    }

    this.segments.forEach(function (segment, index) {
      segment.addEventListener('click', function () {
        self.scrollToIndex(index);
      });
    });

    this.rail.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        step(1);
      }
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        step(-1);
      }
    });
  };

  CncVideoSwipe.prototype.scrollToIndex = function (index) {
    var card = this.cards[index];
    if (!card) return;
    this.rail.scrollTo({ left: card.offsetLeft - this.rail.offsetLeft, behavior: 'smooth' });
  };

  /* Aktive Karte anhand der Rail-Mitte bestimmen */
  CncVideoSwipe.prototype.updateActive = function () {
    var railBox = this.rail.getBoundingClientRect();
    var center = railBox.left + railBox.width / 2;
    var best = 0;
    var bestDistance = Infinity;

    this.cards.forEach(function (card, index) {
      var box = card.getBoundingClientRect();
      var distance = Math.abs(box.left + box.width / 2 - center);
      if (distance < bestDistance) {
        bestDistance = distance;
        best = index;
      }
    });

    this.activeIndex = best;

    this.segments.forEach(function (segment, index) {
      segment.classList.toggle('is-past', index < best);
      segment.setAttribute('aria-current', index === best ? 'true' : 'false');
      if (index > best) segment.querySelector('span').style.width = '0%';
    });

    if (this.prevBtn) this.prevBtn.hidden = this.rail.scrollLeft <= 4;
    if (this.nextBtn) {
      this.nextBtn.hidden = this.rail.scrollLeft + this.rail.clientWidth >= this.rail.scrollWidth - 4;
    }
  };

  /* Fortschrittsbalken läuft mit dem Video der aktiven Karte */
  CncVideoSwipe.prototype.tick = function () {
    var segment = this.segments[this.activeIndex];
    var card = this.cards[this.activeIndex];
    if (segment && card) {
      var video = card.querySelector('video');
      var fill = segment.querySelector('span');
      if (video && fill) {
        var ratio = video.duration ? video.currentTime / video.duration : 0;
        if (reduceMotion.matches || video.paused) ratio = ratio || 1;
        fill.style.width = Math.max(0, Math.min(1, ratio)) * 100 + '%';
      }
    }
    this.ticking = window.requestAnimationFrame(this.tick.bind(this));
  };

  CncVideoSwipe.prototype.setupSectionVisibility = function () {
    var self = this;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          self.inView = entry.isIntersecting;
          if (entry.isIntersecting) {
            if (!self.ticking) self.tick();
            self.updateActive();
            self.playVisible();
          } else {
            if (self.ticking) {
              window.cancelAnimationFrame(self.ticking);
              self.ticking = null;
            }
            self.pauseAll();
          }
        });
      },
      { threshold: 0.15 }
    );
    observer.observe(this.root);
  };

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-cnc-vs]:not([data-cnc-vs-ready])');
    Array.prototype.forEach.call(roots, function (root) {
      new CncVideoSwipe(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  /* Theme-Editor: Section wird neu gerendert */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
  document.addEventListener('shopify:block:select', function (event) {
    var card = event.target.closest('[data-cnc-vs-card]');
    if (card) card.scrollIntoView({ block: 'nearest', inline: 'center' });
  });
})();